import { z } from 'zod';
/**
 * Asesores (advisors) y comisiones de adquisición.
 *
 * Las comisiones se almacenan y transmiten como FRACCIÓN (0.05 = 5%),
 * con un tope de negocio (hard cap) de 0.30 (30%).
 */
/**
 * Tipo de acuerdo con el asesor:
 *  - COMISION_PROYECTO: comisión sobre el ingreso de cada proyecto (entra en el CAP).
 *  - EQUITY: compensación en participaciones; no genera gasto por factura
 *    (la contabilización del equity queda fuera del flujo de comisiones).
 */
export const AdvisorAgreementTypeSchema = z.enum(['COMISION_PROYECTO', 'EQUITY']);
export const AdvisorDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    email: z.string().nullable(),
    /** Comisión por defecto como fracción (0.05 = 5%). */
    defaultCommissionPct: z.number().nullable(),
    /** Organización a través de la que factura el asesor (si aplica). */
    organization: z.string().nullable(),
    /** Cuenta de cobro (IBAN) para automatizar remesas. */
    payoutIban: z.string().nullable(),
    agreementType: AdvisorAgreementTypeSchema,
    notes: z.string().nullable(),
    active: z.boolean(),
});
export const CreateAdvisorSchema = z.object({
    name: z.string().min(1),
    email: z.string().email().nullable().optional(),
    /** Comisión por defecto como fracción (0.05 = 5%). Tope de negocio: 0.30 (30%). */
    defaultCommissionPct: z.number().min(0).max(0.3).nullable().optional(),
    organization: z.string().max(300).nullable().optional(),
    /** IBAN sin validación de checksum; se normaliza quitando espacios y a mayúsculas. */
    payoutIban: z
        .string()
        .max(50)
        .nullable()
        .optional()
        .transform((v) => (v ? v.replace(/\s+/g, '').toUpperCase() : v)),
    agreementType: AdvisorAgreementTypeSchema.default('COMISION_PROYECTO'),
    notes: z.string().nullable().optional(),
    active: z.boolean().default(true),
});
export const UpdateAdvisorSchema = CreateAdvisorSchema.partial();
//# sourceMappingURL=advisors.js.map